// Some customers however always have their people working in different locations (example taxi drivers or promo workers).
// These contracts however should be marked without an actual location but just “On the move” so that they will be extensions.
// To handle this we use 'on_the_move' value for `street` field
export const ON_THE_MOVE = 'on_the_move'
